let pageNumber = 0;

export const getPageNumber = () => pageNumber || 1;
export const increasePageNumber = () => ++pageNumber;
export const resetPageNumber = () => (pageNumber = 0);
